var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9 7V0H41V7H9ZM23.5 3.5C23.5 2.39543 24.3954 1.5 25.5 1.5C26.6046 1.5 27.5 2.39543 27.5 3.5C27.5 4.60457 26.6046 5.5 25.5 5.5C24.3954 5.5 23.5 4.60457 23.5 3.5Z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.6486 9H9L7 14.25L11 50H22.471L24.8242 18.1964L27.1776 50H38.6486L42.6486 14.25L40.6486 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPants);
export default __webpack_public_path__ + "static/media/pants.4eaf30252be43abe2ebd0ee8536193d5.svg";
export { ForwardRef as ReactComponent };